var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12 17.9193 12.1811 18.8295 12.5328 19.6788C12.8846 20.5281 13.4002 21.2997 14.0503 21.9497C14.7003 22.5998 15.4719 23.1154 16.3212 23.4672C17.1705 23.8189 18.0807 24 19 24C19.9193 24 20.8295 23.8189 21.6788 23.4672C22.5281 23.1154 23.2997 22.5998 23.9497 21.9497C24.5998 21.2997 25.1154 20.5281 25.4672 19.6788C25.8189 18.8295 26 17.9193 26 17C26 16.0807 25.8189 15.1705 25.4672 14.3212C25.1154 13.4719 24.5998 12.7003 23.9497 12.0503C23.2997 11.4002 22.5281 10.8846 21.6788 10.5328C20.8295 10.1811 19.9193 10 19 10C18.0807 10 17.1705 10.1811 16.3212 10.5328C15.4719 10.8846 14.7003 11.4002 14.0503 12.0503C13.4002 12.7003 12.8846 13.4719 12.5328 14.3212C12.1811 15.1705 12 16.0807 12 17V17Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8L24.5533 5.10533C24.3872 4.77309 24.1317 4.4937 23.8157 4.29847C23.4997 4.10324 23.1355 3.99989 22.764 4H15.236C14.8645 3.99989 14.5003 4.10324 14.1843 4.29847C13.8683 4.4937 13.6128 4.77309 13.4467 5.10533L12 8H3C2.46957 8 1.96086 8.21071 1.58579 8.58579C1.21071 8.96086 1 9.46957 1 10V26C1 26.5304 1.21071 27.0391 1.58579 27.4142C1.96086 27.7893 2.46957 28 3 28H29C29.5304 28 30.0391 27.7893 30.4142 27.4142C30.7893 27.0391 31 26.5304 31 26V10C31 9.46957 30.7893 8.96086 30.4142 8.58579C30.0391 8.21071 29.5304 8 29 8H26Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12C5.59889 12 5.69556 12.0293 5.77779 12.0843C5.86001 12.1392 5.9241 12.2173 5.96194 12.3087C5.99978 12.4 6.00969 12.5006 5.99039 12.5975C5.9711 12.6945 5.92348 12.7836 5.85355 12.8536C5.78363 12.9235 5.69454 12.9711 5.59755 12.9904C5.50055 13.0097 5.40002 12.9998 5.30866 12.9619C5.2173 12.9241 5.13921 12.86 5.08427 12.7778C5.02932 12.6956 5 12.5989 5 12.5C5 12.3674 5.05268 12.2402 5.14645 12.1464C5.24021 12.0527 5.36739 12 5.5 12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/IconCamera.4bd42a23471c4629d5965d40512cd07d.svg";
export { ForwardRef as ReactComponent };